import { render } from "./toast-body.vue?vue&type=template&id=836dbc38"
import script from "./toast-body.vue?vue&type=script&lang=js"
export * from "./toast-body.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__